<template>
    <div class="grid">
        <div class="col-12">
            <div class="card">
                <h3>Invoice</h3>
                <div class="font-medium text-500 mb-3">Create Invoice For Client</div>
                <div class="field grid">
                    <label for="name3" class="col-12 mb-2 md:col-3 md:mb-0 font-medium">No Invoice</label>
                    <InputText id="is_present" v-model="form.no_invoice" name="is_present" />
                </div>
                <div class="field grid">
                    <label for="name3" class="col-12 mb-2 md:col-3 md:mb-0 font-medium">Tgl Invoice</label>
                    <Calendar :showIcon="true" :showButtonBar="true"
                            :class="{ 'p-invalid': submitted && !form.date }" v-model="form.date"
                            dateFormat="yy-mm-dd" />
                        <small class="p-invalid" v-if="submitted && !form.date">Date invoice is required.</small>
                </div>
                <div class="field grid">
                    <label for="name3" class="col-12 mb-2 md:col-3 md:mb-0 font-medium">Billed To</label>
                    <Dropdown
                            v-model="form.billed_to" :options="placements" optionLabel="name"
                            optionValue="id" placeholder="Select Billed To" />
                </div>
                <div class="field grid">
                    <label for="name3" class="col-12 mb-2 md:col-3 md:mb-0 font-medium">Amount</label>
                    <InputNumber id="amount" mode="decimal" locale="id-ID" v-model="form.amount" :class="{'p-invalid' : submitted && !form.amount }"/>
                        <small class="p-invalid" v-if="submitted && !form.amount"
                            >Amount is required.</small
                        >
                    <div class="col-12 mt-2 md:col-2">
                        <Checkbox id="isPPH" v-model="form.is_pph" :binary="true" name="Passed" />
                        <label for="isPassed">PPH (2%)</label>
                    </div>
                    <div class="col-12 mt-2 md:col-2">
                        <Checkbox id="isPPN" v-model="form.is_ppn" :binary="true" name="Passed" />
                        <label for="isPassed">PPN (11%)</label>
                    </div>

                </div>
                <div class="field grid">
                    <label for="name3" class="col-12 mb-2 md:col-3 md:mb-0 font-medium">Fee Service (8.5%)</label>
                    <InputNumber id="fee" mode="decimal" locale="id-ID" v-model="totalFee" disabled="true"/>
                </div>
                <div class="field grid">
                    <label for="name3" class="col-12 mb-2 md:col-3 md:mb-0 font-medium">Description</label>
                    <Textarea id="description" rows="4" cols="40" v-model="form.description"/>
                </div>
                <div class="field grid">
                    <label for="name3" class="col-12 mb-2 md:col-3 md:mb-0 font-medium">Created By</label>
                    <AutoComplete forceSelection placeholder="Search" id="dd" :dropdown="true"
                        v-model="selectedCreatedBy" :suggestions="autoFilteredValue"
                        @complete="searchEmployee($event)" @item-select="selectCreatedBy" field="name"
                        :class="{ 'p-invalid': submitted && !selectedCreatedBy }"
                        />
                    <small class="p-invalid" v-if="submitted && !selectedCreatedBy">
                        Created By is required.
                    </small>
                </div>
                <div class="field grid">
                    <label for="name3" class="col-12 mb-2 md:col-3 md:mb-0 font-medium">Approved By</label>
                    <AutoComplete forceSelection placeholder="Search" id="dd" :dropdown="true"
                            v-model="selectedApprovedBy" :suggestions="autoFilteredValue"
                            @complete="searchEmployee($event)" @item-select="selectApprovedBy" field="name"
                            :class="{ 'p-invalid': submitted && !selectedApprovedBy }"
                        />
                    <small class="p-invalid" v-if="submitted && !selectedApprovedBy">
                        Created By is required.
                    </small>
                </div>
                <Button :loading="isSaving" @click="save" id="button1" label="Save" />
            </div>
        </div>
    </div>
</template>
<script>
import AppLayoutVue from '../../Layouts/AppLayout.vue';
import AutoComplete from 'primevue/autocomplete';
import Button from 'primevue/button';
import Calendar from 'primevue/calendar';
import Checkbox from 'primevue/checkbox';
import Dropdown from 'primevue/dropdown';
import InputText from 'primevue/inputtext';
import InputNumber from 'primevue/inputnumber';
import Textarea from 'primevue/textarea';
import axios from 'axios';

export default{
    layout: AppLayoutVue,
    components: {AutoComplete, Button, Calendar, Checkbox, Dropdown, InputText, InputNumber, Textarea} ,
    data(){
        return {
            form: this.$page.props.invoice ?? {
                description: "Pembayaran Tagihan Tenaga Security Sebanyak 1 orang (Anggota) Periode : 01 - 30 November 2022",
                amount: 0,
                is_pph: true,
                is_ppn: true,
            },
            placements: {},
            submitted: false,
            autoFilteredValue: [],
            selectedCreatedBy: this.$page.props.invoice ? this.$page.props.invoice.createdBy : '',
            selectedApprovedBy: this.$page.props.invoice ? this.$page.props.invoice.approvedBy :  '',
            isEdit: this.$page.props.invoice ? true : false,
            isSaving: false,
        }
    },
    computed: {
        totalFee(){
            return this.form.amount * 8.5 / 100;
        }
    },
    mounted(){
        this.initData();
    },
    methods: {
        searchEmployee(event) {
            setTimeout(() => {
                if (!event.query.trim().length) {
                    axios.get(`${this.$page.props.appUrl}api/employees`)
                        .then((data) => {
                            this.autoFilteredValue = data.data.data;
                        });
                }
                else {
                    let filterValue = event.query.toLowerCase();
                    axios.get(`${this.$page.props.appUrl}api/employees?search=${filterValue}`)
                        .then((data) => {
                            this.autoFilteredValue = data.data.data;
                        });
                }
            }, 250);
        },
        selectCreatedBy() {
            axios.get(`${this.$page.props.appUrl}api/employees/${this.selectedCreatedBy.id}`)
            .then((data) => {
                this.form.created_by = this.selectedCreatedBy.id;
            });
        },
        selectApprovedBy() {
            axios.get(`${this.$page.props.appUrl}api/employees/${this.selectedApprovedBy.id}`)
            .then((data) => {
                this.form.approved_by = this.selectedApprovedBy.id;
            });
        },
        initData(){
            axios.get(`${this.$page.props.appUrl}api/placement-units`)
                .then((data) => {
                    this.placements = data.data;
                })
                .catch((error) => {
                    this.$toast.add({
                        severity: "error",
                        summary: "Error",
                        detail: "Can't Get Data Placement, Refresh Again in 5 second. If still not shown contact support",
                        life: 3000,
                    });
                });
        },
        clearForm(){
            this.form = {
                    description: "Pembayaran Tagihan Tenaga Security Sebanyak xx orang (Anggota) Periode :xx - xx November 2022",
                    amount: 0,
                    is_pph: true,
                    is_ppn: true,
                };
            this.selectedApprovedBy= '';
            this.selectedCreatedBy= '';
        },
        save(){
            this.isSaving = true;
            this.submitted = true;

            this.form.created_by = this.selectedCreatedBy.id;
            this.form.approved_by = this.selectedApprovedBy.id;

            if(this.isEdit){
                axios.put(`${this.$page.props.appUrl}api/invoices/${this.$page.props.invoice.id}`,this.form)
                .then((data) => {
                    this.clearForm();
                    this.submitted = false;

                    this.$toast.add({
                        severity: "success",
                        summary: "Successful",
                        detail: "Invoice Updated",
                        life: 3000,
                    });
                })
                .catch((error) => {
                    this.$toast.add({
                        severity: "error",
                        summary: "Error When Updating Invoice",
                        detail: error,
                        life: 3000,
                    });
                })
            }else{
                axios.post(`${this.$page.props.appUrl}api/invoices`,this.form)
                .then((data) => {
                    this.clearForm();
                    this.submitted = false;

                    this.$toast.add({
                        severity: "success",
                        summary: "Successful",
                        detail: "Invoice Created",
                        life: 3000,
                    });
                })
                .catch((error) => {
                    this.$toast.add({
                        severity: "error",
                        summary: "Error When Creating Invoice",
                        detail: error,
                        life: 3000,
                    });
                })
            }

            this.isSaving = false;
        },
    }
}

</script>
